	export enum ProductStylePositionEnum {
		HearingAidRight = 1,
    HearingAidLeft = 2,
		Option1Right = 3,
		Option2Right = 4,
		Option3Right = 5,
		Option4Right = 6,
		Option1Left = 7,
		Option2Left = 8,
		Option3Left = 9,
		Option4Left = 10,
		EarMoldRight = 11,
    EarMoldLeft = 12,
    ReceiverRight = 13,
    ReceiverLeft = 14
	}
